import React, { useEffect, useState } from "react";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";
import { Form, Input, Button, message, Select } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Sidebars from "../../Components/Sidebar/sidebar";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import { Modal } from 'antd';
import { getDateString } from "../../config/functions";
import MyRichTextEditor from "../../Components/RichTextEditor";
import { VEH_AGREEMENT_URL } from "../../Api/constants";
const { Option } = Select;

// Document list items
const documentItems = [
    { key: 'pco_license_front', label: 'PCO License Front' },
    { key: 'pco_license_back', label: 'PCO License Back' },
    { key: 'driving_license_front', label: 'Driving License Front' },
    { key: 'driving_license_back', label: 'Driving License Back' },
    { key: 'proof_of_address', label: 'Proof of Address' },
    { key: 'pco_license_paper', label: 'PCO License Paper' },
];


const UserDetails = () => {



    const { id } = useParams();

    const navigate = useNavigate();
    const theme = useTheme();
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);

    const [vehicle, setVehicle] = useState([]);
    const [reports, setReports] = useState();
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [isAddNote, setIsAddNote] = useState('');
    const [customerNotes, setCustomerNotes] = useState([]);

    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // ≤600px
    const isTablet = useMediaQuery(theme.breakpoints.only('sm')); // 600–900px

    const history = useNavigate();

    const getCustomerDetails = async () => {
        const onSuccess = (res) => {
            console.log('res', res);

            setVehicle(res.data);
            setReports(res.reports);
            dispatch(setLoader(false));
        }
        const onError = (err) => {
            console.log('err', err)
            err?.data?.error && alert(err.data.error);
            dispatch(setLoader(false));
        }

        const body = {
            cust_id: id,
            token: user?.token
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getCustDetails, onSuccess, onError);


    }

    const moveTrash = async () => {
        setConfirmDelete(false);
        const onSuccess = (res) => {
            console.log('res', res);
            history('/vehicles');
            dispatch(setLoader(false));
        }
        const onError = (err) => {
            console.log('err', err)
            err?.data?.error && message.error(err.data.error);
            dispatch(setLoader(false));
        }

        const body = {
            veh_id: id,
            token: user?.token
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.moveVehicleToTrash, onSuccess, onError);

    }


    const saveNote = async (value) => {

        const onSuccess = (res) => {
            setIsAddNote(false);
            setCustomerNotes(res.customer_notes)
            message.success('Note saved!');
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            cust_id: id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.addCustomerNotes, onSuccess, onError);


    }

    const getCustomerNotes = async (value) => {

        const onSuccess = (res) => {

            setCustomerNotes(res.data);
            dispatch(setLoader(false));
        }

        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to get notes');
        }
        const body = {
            token: user?.token,
            cust_id: id,
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getCustomerNotes, onSuccess, onError);
    }


    const updateNote = async (value, note_id, cb) => {

        const onSuccess = () => {
            dispatch(setLoader(false));
            message.success('Note saved!');
            // navigate(`/agreement-notes/${ids.id}`);
            cb();
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            note_id: note_id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.updateCustomerNote, onSuccess, onError);


    }

    const deleteNote = async (note_id) => {

        const onSuccess = (res) => {
            dispatch(setLoader(false));
            message.success('Note deleted!');
            setCustomerNotes(res.customer_notes)

        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to delete note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            note_id: note_id,
            cust_id: id
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.deleteCustomerNote, onSuccess, onError);


    }






    useEffect(() => {
        getCustomerDetails();
        getCustomerNotes();
    }, [])

    const RenderAgreements = React.useCallback(
        () => {
            {
                return customerNotes?.map((v, i) => {
                    return (
                        <div style={{ width: "100%", }}>
                            <Typography style={{ color: appColors.black, fontSize: 16, fontFamily: 'Poppins', marginLeft: 10, marginTop: 20 }}>Created at: {new Date(v.created_at).toLocaleString()}</Typography>

                            <MyRichTextEditor
                                disabled={true}
                                val={v.note}
                                data={v}
                                edit={true}
                                del={true}
                                onSave={(value, cb = () => { }) => updateNote(value, v.cn_id, cb)}
                                onDelete={() => deleteNote(v.cn_id)}
                            />
                        </div>
                    )
                })
            }
        },
        [customerNotes],
    )

    const StatCard = ({ title, value }) => (
        <Box
            sx={{
                bgcolor: 'white',
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                textAlign: 'center',
            }}
        >
            <Box sx={{ bgcolor: appColors.primaryLight, py: 1.5 }}>
                <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 600, fontFamily: 'Poppins' }}>
                    {title}
                </Typography>
            </Box>
            <Box sx={{ py: 2.5 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, fontFamily: 'Poppins' }}>
                    {value}
                </Typography>
            </Box>
        </Box>
    );
    const InfoRow = ({ label, value, fullWidth = false }) => (
        <Box sx={{ display: fullWidth ? 'block' : 'flex', flexDirection: 'column' }}>
            <Typography variant="caption" color="text.secondary" sx={fieldText}>
                {label}
            </Typography>
            <Typography variant="body2" sx={valueText}>
                {value || '—'}
            </Typography>
        </Box>
    );

    const DocumentCard = ({ label, url }) => (
        <Box
            onClick={() => window.open(url, '_blank')}
            sx={{
                p: 2.5,
                bgcolor: '#fafafa',
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'all 0.15s',
                '&:hover': {
                    bgcolor: '#f5f5f5',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                },
            }}
        >
            <Typography sx={{ fontWeight: 500,fontFamily:'Poppins' }}>{label}</Typography>
            <Button type="link" size="small">
                Open →
            </Button>
        </Box>
    );
    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', minHeight: '100vh' }}>
                    {/* Sidebar - hide on mobile or make it collapsible */}
                    <Sidebars />

                    {/* Main content - takes full width on mobile */}
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            p: { xs: 2, sm: 3 },
                            width: '100%',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                        }}
                    >
                        {/* Header */}
                        <Typography
                            variant="h5"
                            component="h1"
                            className="headertext"
                            sx={{
                                mb: 3,
                                fontWeight: 600,
                                color: appColors.primary,
                                fontFamily: 'Poppins'
                            }}
                        >
                            Customer Details
                        </Typography>

                        {/* Stats cards - become stacked on mobile */}
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: {
                                    xs: '1fr',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                },
                                gap: 2,
                                mb: 4,
                            }}
                        >
                            <StatCard
                                title="Total Agreements"
                                value={reports?.total_agreements ?? '-'}
                            />
                            <StatCard
                                title="Paid / Total Invoices"
                                value={`${reports?.total_paid_amount ?? '-'} / ${reports?.total_invoice_amount ?? '-'}`}
                            />
                            <StatCard
                                title="Total Rented cars"
                                value={reports?.total_rented_persons ?? '-'}
                            />
                        </Box>

                        {/* Customer Info Card */}
                        <Box
                            sx={{
                                bgcolor: 'white',
                                borderRadius: 2,
                                p: 3,
                                mb: 4,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h6" sx={{ color: appColors.primary, fontFamily: 'Poppins', fontWeight: '800' }}>
                                    Personal Information
                                </Typography>

                                <Box sx={{ display: 'flex', gap: 1.5 }}>
                                    <Button
                                        variant="outlined"
                                        size={isMobile ? "small" : "medium"}
                                        onClick={() => navigate(`/edit-user/${id}`)}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size={isMobile ? "small" : "medium"}
                                        onClick={() => navigate(`/customer-history/${id}`)}
                                    >
                                        See Report
                                    </Button>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                    gap: { xs: 2, sm: 3 },
                                    rowGap: 1.5,
                                }}
                            >
                                <InfoRow label="Name" value={vehicle?.name} />
                                <InfoRow label="Email" value={vehicle?.email} />
                                <InfoRow label="Phone" value={vehicle?.phone} />
                                <InfoRow label="Alternate Phone" value={vehicle?.alternate_phone} />
                                <InfoRow label="License number" value={vehicle?.license_number} />
                                <InfoRow label="License exp date" value={getDateString(vehicle?.license_exp_date)} />
                                <InfoRow label="Created at" value={getDateString(vehicle?.created_at)} />
                                <InfoRow label="Postal code" value={vehicle?.postal_code} />
                                <InfoRow label="Date of birth" value={getDateString(vehicle?.dob)} />
                                <InfoRow fullWidth label="Address" value={vehicle?.address} />
                                <InfoRow label="Next of kin name" value={vehicle?.kins_name} />
                                <InfoRow label="Kins phone" value={vehicle?.kins_phone} />
                                <InfoRow label="Kins email" value={vehicle?.kins_email} />
                                <InfoRow label="Kins relation" value={vehicle?.kins_relation} />
                                <InfoRow fullWidth label="Kins Address" value={vehicle?.kins_address} />
                            </Box>
                        </Box>

                        {/* Notes Section */}
                        <Box
                            sx={{
                                bgcolor: 'white',
                                borderRadius: 2,
                                overflow: 'hidden',
                                mb: 4,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            }}
                        >
                            <Box
                                sx={{
                                    bgcolor: appColors.primary,
                                    color: 'white',
                                    p: 2,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    Notes
                                </Typography>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{ bgcolor: 'white', color: appColors.primary, '&:hover': { bgcolor: '#f0f0f0' } }}
                                    startIcon={isAddNote ? <RemoveIcon /> : <AddIcon />}
                                    onClick={() => setIsAddNote(!isAddNote)}
                                >
                                    {isAddNote ? 'Close' : 'Add Note'}
                                </Button>
                            </Box>

                            {isAddNote && (
                                <Box sx={{ p: 3, borderTop: `1px solid ${appColors.grey}` }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Add new note
                                    </Typography>
                                    <MyRichTextEditor
                                        submitButtonText="Add note"
                                        onSave={saveNote}
                                    />
                                </Box>
                            )}

                            {customerNotes?.length === 0 && !isAddNote && (
                                <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
                                    You have no notes for this customer yet
                                </Box>
                            )}

                            {customerNotes?.map((note) => (
                                <Box
                                    key={note.cn_id}
                                    sx={{
                                        p: 3,
                                        borderTop: `1px solid ${appColors.grey}`,
                                        '&:first-of-type': { borderTop: 'none' },
                                    }}
                                >
                                    <Typography variant="caption" color="text.secondary" gutterBottom>
                                        {new Date(note.created_at).toLocaleString()}
                                    </Typography>

                                    <MyRichTextEditor
                                        disabled={true}
                                        val={note.note}
                                        data={note}
                                        edit={true}
                                        del={true}
                                        onSave={(value, cb) => updateNote(value, note.cn_id, cb)}
                                        onDelete={() => deleteNote(note.cn_id)}
                                    />
                                </Box>
                            ))}
                        </Box>

                        {/* Documents Section */}
                        <Box>
                            <Typography variant="h6" sx={{ mb: 2, color: appColors.primary, fontWeight: 600,fontFamily:'Poppins' }}>
                                Customer Documents
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {documentItems.map((doc) =>
                                    vehicle?.[doc.key] ? (
                                        <DocumentCard
                                            key={doc.key}
                                            label={doc.label}
                                            url={`${VEH_AGREEMENT_URL}${vehicle[doc.key]}`}
                                        />
                                    ) : null
                                )}
                            </Box>
                        </Box>
                    </Box>
                </div>

                {/* Delete Confirmation Modal */}
                <Modal
                    title="Are you sure you want to delete this vehicle?"
                    open={confirmDelete}
                    onCancel={() => setConfirmDelete(false)}
                    footer={[
                        <Button key="cancel" onClick={() => setConfirmDelete(false)}>
                            Cancel
                        </Button>,
                        <Button danger key="delete" onClick={moveTrash}>
                            Delete
                        </Button>,
                    ]}
                >
                    {/* <p>Are you sure you want to delete this vehicle?</p> */}
                </Modal>


                <div style={{ display: 'flex', }}>
                    <Sidebars />

                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
                        <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
                            Customer Details
                        </span>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', }}>

                            <div style={infoContainer}>
                                <div style={infoHeadingContainer}>
                                    <Typography sx={infoHeading} >
                                        Total Agreements
                                    </Typography>
                                </div>
                                <div style={infoValueContainer}>
                                    <Typography sx={infoValue} >
                                        {reports?.total_agreements}
                                    </Typography>
                                </div>
                            </div>
                            <div style={infoContainer}>
                                <div style={infoHeadingContainer}>
                                    <Typography sx={infoHeading} >
                                        Paid / Total Invoices Amounts
                                    </Typography>
                                </div>
                                <div style={infoValueContainer}>
                                    <Typography sx={infoValue} >
                                        {reports?.total_paid_amount}/{reports?.total_invoice_amount}
                                    </Typography>
                                </div>
                            </div>
                            <div style={infoContainer}>
                                <div style={infoHeadingContainer}>
                                    <Typography sx={infoHeading} >
                                        Total Rented cars
                                    </Typography>
                                </div>
                                <div style={infoValueContainer}>
                                    <Typography sx={infoValue} >
                                        {reports?.total_rented_persons}
                                    </Typography>
                                </div>
                            </div>
                            {/* <div style={infoContainer}>
                                <div style={infoHeadingContainer}>
                                    <Typography sx={infoHeading} >
                                        Total Weeks
                                    </Typography>
                                </div>
                                <div style={infoValueContainer}>
                                    <Typography sx={infoValue} >
                                        5
                                    </Typography>
                                </div>
                            </div> */}

                        </div>

                        <div style={{ display: 'flex', width: "100%", borderRadius: 5, flexDirection: 'row', padding: 5, paddingTop: 10, backgroundColor: 'white', marginTop: 20, paddingLeft: 20 }} >
                            {/* <div style={{ width: 220, height: 180, borderRadius: 5, alignItems: 'center', justifyContent: 'center', backgroundColor: appColors.grey }}>
                                {
                                    vehicle?.images?.length &&
                                    <Carousel
                                        indicators={false} // Hide the dots

                                        style={{ height: 180, borderRadius: 10, marginTop: 5 }} >
                                        {vehicle?.images.map((image, index) => (
                                            <Item key={index} image={VEH_IMAGE_URL + image} />
                                        ))}
                                    </Carousel>
                                }
                            </div> */}
                            <div style={{ marginLeft: 15, display: 'flex', flexDirection: 'column', width: "40%" }}>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Name</Typography>
                                        <Typography sx={valueText} >{vehicle?.name}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Email</Typography>
                                        <Typography sx={valueText} >{vehicle?.email}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Phone</Typography>
                                        <Typography sx={valueText} >{vehicle?.phone}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Alternate Phone</Typography>
                                        <Typography sx={valueText} >{vehicle?.alternate_phone}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >License number</Typography>
                                        <Typography sx={valueText} >{vehicle?.license_number}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >License exp date</Typography>
                                        <Typography sx={valueText} >{getDateString(vehicle?.license_exp_date)}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Created at</Typography>
                                        <Typography sx={valueText} >{getDateString(vehicle.created_at)}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Postal code</Typography>
                                        <Typography sx={valueText} >{vehicle.postal_code}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Date of birth</Typography>
                                        <Typography sx={valueText} >{getDateString(vehicle.dob)}</Typography>
                                    </div>
                                    {/* <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Postal code</Typography>
                                        <Typography sx={valueText} >{vehicle.postal_code}</Typography>
                                    </div> */}
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={{ width: "100%", display: 'flex', flexDirection: 'row' }}>
                                        <Typography sx={{ ...fieldText }} >Address</Typography>
                                        <Typography sx={{ ...valueText, marginLeft: 2 }} >{vehicle.address}</Typography>
                                    </div>
                                </div>

                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Kins name</Typography>
                                        <Typography sx={valueText} >{vehicle.kins_name}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Kins phone</Typography>
                                        <Typography sx={valueText} >{vehicle.kins_phone}</Typography>
                                    </div>
                                </div>
                                <div style={vehicleRowContainer}>
                                    <div style={vehicleRow1}>
                                        <Typography sx={fieldText} >Kins email</Typography>
                                        <Typography sx={valueText} >{vehicle.kins_email}</Typography>
                                    </div>
                                    <div style={vehicleRow2}>
                                        <Typography sx={fieldText} >Kins relation</Typography>
                                        <Typography sx={valueText} >{vehicle.kins_relation}</Typography>
                                    </div>
                                </div>

                                <div style={vehicleRowContainer}>
                                    <div style={{ width: "100%", display: 'flex', flexDirection: 'row' }}>
                                        <Typography sx={{ ...fieldText }} >Kins Address</Typography>
                                        <Typography sx={{ ...valueText, marginLeft: 2 }} >{vehicle.kins_address}</Typography>
                                    </div>
                                </div>

                            </div>

                            <div>
                                <div
                                    onClick={() => history(`/edit-user/${id}`)}
                                    style={{ width: 50, height: 29, borderStyle: 'solid', borderRadius: 20, display: 'flex', borderWidth: 1, borderColor: appColors.primary, alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginLeft: 10 }}>
                                    <Typography sx={{ fontSize: 12, color: appColors.primary, fontFamily: 'Poppins', fontWeight: 600 }} >Edit</Typography>
                                </div>

                                <div
                                    onClick={() => history(`/customer-history/${id}`)}
                                    style={{ width: 80, height: 29, borderStyle: 'solid', borderRadius: 20, display: 'flex', borderWidth: 1, borderColor: appColors.primary, alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginLeft: 10, marginTop: 10 }}>
                                    <Typography sx={{ fontSize: 12, color: appColors.primary, fontFamily: 'Poppins', fontWeight: 600 }} >See Report</Typography>
                                </div>

                            </div>

                        </div>



                        <div style={{ display: 'flex', flexDirection: 'column', width: "100%", borderRadius: 10, backgroundColor: appColors.white, marginTop: 10, paddingBottom: 10 }}>
                            <div style={{ width: "100%", height: 45, borderTopRightRadius: 10, borderTopLeftRadius: 10, backgroundColor: appColors.primary, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Typography style={{ color: appColors.white, fontSize: 16, fontWeight: 600, marginLeft: 10, marginTop: 10 }}>Notes</Typography>
                                <div
                                    onClick={() => setIsAddNote(!isAddNote)}
                                    style={{ cursor: 'pointer', height: 20, alignSelf: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', padding: 5, borderRadius: 50, marginRight: 10 }}>
                                    {
                                        isAddNote ?
                                            <RemoveIcon />
                                            :
                                            <AddIcon style={{ color: appColors.primary, fontSize: 24 }} />
                                    }
                                </div>
                            </div>
                            {
                                isAddNote &&
                                <div style={{ borderWidth: 1, borderStyle: 'solid', width: "99%", marginTop: 10, display: 'flex', alignSelf: 'center', flexDirection: 'column', borderColor: appColors.greyText }}>
                                    <div style={{ display: 'flex', marginTop: 10, marginBottom: 5, alignSelf: 'center', fontFamily: 'Poppins', }} >
                                        Add new note
                                    </div>
                                    <MyRichTextEditor
                                        submitButtonText="Add note"
                                        onSave={(value) => saveNote(value)}
                                    />
                                </div>
                            }
                            {
                                !customerNotes?.length &&
                                <div style={{ display: 'flex', marginTop: 20, marginBottom: 10, alignSelf: 'center', fontFamily: 'Poppins', }} >
                                    You have no notes for this customers
                                </div>
                            }
                            <RenderAgreements />

                        </div>



                    </div>
                </div>
                />
            </ThemeProvider>
        </>
    )

}

const infoContainer = {
    width: 250, borderRadius: 10, backgroundColor: appColors.white, padding: 5, paddingBottom: 20
}

const infoHeadingContainer = {
    width: "100%", backgroundColor: appColors.primaryLight,
    borderTopRightRadius: 10, borderTopLeftRadius: 10,
    height: 40, alignItems: 'center', justifyContent: 'center', display: 'flex'
}

const infoHeading = {
    fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600
}

const infoValueContainer = {
    display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", marginTop: 15,
}

const infoValue = {
    fontSize: 14, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const vehicleRowContainer = {
    borderStyle: 'dashed', borderTop: 'none', borderRight: 'none', borderLeft: 'none', borderColor: appColors.grey,
    display: 'flex', flexDirection: 'row', width: "100%", justifyContent: 'space-between', height: 'auto',
    marginTop: 5, paddingBottom: 3

}

const vehicleRow1 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const vehicleRow2 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const fieldText = {
    fontSize: 12, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const valueText = {
    fontSize: 12, color: appColors.greyText, fontFamily: 'Poppins', fontWeight: 600,
}

export default UserDetails
